import { app } from '../../app.module'
app
  // アカウントタグ管理モーダル
  .directive('batchTagModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $mdDialog) => {
        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
